import React, {useEffect, useState} from "react";
import {AccountSearchInterface} from "../../../../pages/customer/correspondent/list/interface/searchInterface";
import {SubmitHandler, useForm} from "react-hook-form";
import {useReadContactList} from "../../../../pages/customer/contact/hooks";
import EmptyTableRow from "../../../../pages/common/EmptyTableRow";
import {SearchContactType} from "../../../../pages/customer/contact/interface";
import { RmaUserDataType } from '../../../../types/support/index';
import {ModalInnerConfirmType} from "../interface";
import {useModal} from "../../../../hooks";
import PaginationSub from "../../pagination/PaginationSub";
import { useReadUserData } from "../../../../pages/support/rma/hooks/useReadUserData";

/**
 * 연락처 검색 모달
 * @param props
 * @returns
 */
export const SearchUserDataInner = ({
                                        confirmCallback,
                                        cancelCallback,
                                        modalDepth,
                                    }: ModalInnerConfirmType<RmaUserDataType>) => {
    const defaultSearchValue = {
        keywordType: "0",
        keyword: "",
        limit: 10,
        pageNo: "1",
        accountId: "",
    };

    const {handleModal, resetModal} = useModal();

    const [searchOption, setSearchOption] = useState<
        AccountSearchInterface & { accountId: string }
    >(defaultSearchValue);
    const [selectItem, setSelectItem] = useState<RmaUserDataType | null>(null);
    const {data} = useReadUserData({
        searchOption: searchOption,
    });

    /*
    const {data} = useReadContactList({
        searchOption: searchOption,
    });
    * */

    useEffect(() => {
        console.log()
    },[]);
    const {register, handleSubmit} = useForm({
        defaultValues: searchOption,
    });

    const onSubmit: SubmitHandler<
        AccountSearchInterface & { accountId: string }
    > = (submitData) => {
        setSearchOption(submitData);
    };

    const onClose = () => {
        resetModal(modalDepth);
    };

    const onConfirm = () => {
        if (selectItem?.userId) {
            confirmCallback(selectItem);
            onClose();
        } else {
            handleModal({
                isOpen: true,
                contents: "연락처를 선택해주세요.",
                type: "alert",
                depth: modalDepth + 1,
            });
        }
    };

    const onCancel = () => {
        onClose();
        cancelCallback && cancelCallback();
    };

    return (
        <>
            <form className="d-flex mb-15px" onSubmit={handleSubmit(onSubmit)}>
                <select className="form-select w-120px" {...register("keywordType")}>
                    <option value="0">전체</option>
                    <option value="1">이름</option>
                    <option value="2">핸드폰</option>
                    <option value="3">이메일</option>
                </select>
                <input
                    type="text"
                    className="form-control w-250px ms-5px h-34px"
                    {...register("keyword")}
                />
                <button type="submit" className="btn btn-info btn_search w-80px ms-5px">
                    <img
                        src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}
                        alt=""
                    />
                    조회
                </button>
            </form>

            <table className="table table-bordered my_table table_modal">
                <thead>
                <tr>
                    <th style={{ width: "3%" }}></th>
                    <th style={{ width: "20%" }}>이름</th>
                    <th style={{ width: "17%" }}>이메일</th>
                    <th style={{ width: "25%" }}>직함</th>
                    <th style={{ width: "15%" }}>휴대폰</th>
                </tr>
                </thead>
                <tbody>
                {(data?.userVOList ?? [])?.length === 0 ? (
                    <EmptyTableRow/>
                ) : (
                    (data?.userVOList ?? [])?.map((item: any) => {
                        return (
                            <tr className={`clickable ${item.userId === selectItem?.userId ? "lightblue" : ""}`}
                                onClick={() => setSelectItem(item)}>
                                <td>
                                    <div className="checkbox_outer">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            onClick={() => {
                                                setSelectItem(item);
                                            }}
                                            checked={selectItem?.userId === item?.userId}
                                        />
                                    </div>
                                </td>
                                <td className="text-center">{item?.userName}</td>
                                <td className="text-center">{item?.loginId}</td>
                                <td className="text-center">{item?.title}</td>
                                <td className="text-center">{item?.contactNo}</td>

                            </tr>
                        );
                    })
                )}
                </tbody>
            </table>

            <PaginationSub
                totalCount={data?.totalCount ?? 0}
                currentPage={Number(searchOption.pageNo)}
                onChangeCallback={(i) =>
                    setSearchOption({...searchOption, pageNo: i})
                }
            />

            <div className="mt-3 d-flex align-items-center justify-content-end">
                <button
                    type="button"
                    className="btn btn-outline-primary w-100px h-38px my-0"
                    onClick={onCancel}
                >
                    취소
                </button>
                <button
                    type="button"
                    className="btn btn-dark w-100px h-38px my-0 ms-3"
                    onClick={onConfirm}
                >
                    선택
                </button>
            </div>
        </>
    );
};
